import axios from 'axios';

// Get CSRF token from meta tag
const getCSRFToken = () => {
  const token = document.querySelector('meta[name="csrf-token"]');
  const tokenValue = token ? token.getAttribute('content') : '';
  console.log('[KidDashboard API] getCSRFToken called, token exists:', !!token, 'value length:', tokenValue.length);
  return tokenValue;
};

// Create axios instance with base configuration
console.log('[KidDashboard API] Creating axios client with baseURL: /api/children');
const apiClient = axios.create({
  baseURL: '/api/children',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-CSRF-Token': getCSRFToken()
  }
});

// Add request interceptor to ensure CSRF token is always fresh
apiClient.interceptors.request.use(config => {
  console.log('[KidDashboard API] Request interceptor - URL:', config.url, 'Method:', config.method);
  config.headers['X-CSRF-Token'] = getCSRFToken();
  return config;
});

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  response => {
    console.log('[KidDashboard API] Response success - URL:', response.config.url, 'Status:', response.status);
    return response;
  },
  error => {
    console.log('[KidDashboard API] Response error - Status:', error.response?.status, 'URL:', error.config?.url);
    console.log('[KidDashboard API] Error details:', error.message);
    if (error.response?.status === 401) {
      console.log('[KidDashboard API] 401 Unauthorized detected - redirecting to /login');
      // Redirect to login if unauthorized
      // Return a never-resolving promise to prevent error handling in React
      // while the redirect is happening
      window.location.href = '/login';
      return new Promise(() => {}); // Never resolves, redirect will happen
    }
    return Promise.reject(error);
  }
);

export default apiClient;
